export default function WaveformMark({ className = "w-8 h-8 text-ink" }) {
  // Voice → Evidence: soundwave morphing into structured bars
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      data-testid="brand-waveform-mark"
    >
      <g stroke="currentColor" strokeWidth="2" strokeLinecap="square">
        {/* wave side - rounded caps */}
        <line x1="4" y1="32" x2="4" y2="32" strokeLinecap="round" />
        <line x1="9" y1="26" x2="9" y2="38" strokeLinecap="round" />
        <line x1="14" y1="20" x2="14" y2="44" strokeLinecap="round" />
        <line x1="19" y1="14" x2="19" y2="50" strokeLinecap="round" />
        <line x1="24" y1="22" x2="24" y2="42" strokeLinecap="round" />
        <line x1="29" y1="28" x2="29" y2="36" strokeLinecap="round" />
      </g>
      {/* connector */}
      <path d="M32 32 L40 32" stroke="#C84C21" strokeWidth="2" />
      {/* evidence side - sharp bars */}
      <g fill="currentColor">
        <rect x="42" y="22" width="3" height="20" />
        <rect x="48" y="14" width="3" height="36" />
        <rect x="54" y="26" width="3" height="12" />
        <rect x="60" y="20" width="2" height="24" />
      </g>
    </svg>
  );
}
